import ReportTrend from "./ReportTrend";
export default ReportTrend;